/* Asfar Al-Ummah — shared site behaviour (NL / AR / EN / FR) */
(function () {
  "use strict";

  var STORAGE_KEY = "asfar-lang";
  var LANGS = ["nl", "ar", "en", "fr"];
  var LANG_NAMES = { nl: "Nederlands", ar: "العربية", en: "English", fr: "Français" };
  var htmlEl = document.documentElement;

  /* ---------- inject dropdown CSS once ---------- */
  function injectStyles() {
    if (document.getElementById("asfar-lang-style")) return;
    var css = ".lang-switch{position:relative}" +
      ".lang-toggle-btn{display:flex;align-items:center;gap:6px;border:1px solid var(--navy,#132241);border-radius:999px;background:transparent;padding:7px 14px;font-size:.72rem;letter-spacing:.04em;color:var(--navy,#132241);cursor:pointer;font-family:inherit;min-height:38px}" +
      ".lang-toggle-btn svg{width:11px;height:11px;stroke:var(--navy,#132241);transition:transform .2s ease}" +
      ".lang-switch.open .lang-toggle-btn svg{transform:rotate(180deg)}" +
      ".lang-menu{position:absolute;top:calc(100% + 8px);right:0;background:var(--white,#fff);border:1px solid rgba(19,34,65,.1);border-radius:8px;box-shadow:0 20px 50px rgba(19,34,65,.12);min-width:150px;padding:6px;display:none;flex-direction:column;gap:2px;z-index:300}" +
      "html[dir='rtl'] .lang-menu{right:auto;left:0}" +
      ".lang-menu.open{display:flex}" +
      ".lang-menu button{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 12px;border:none;background:none;border-radius:5px;font-size:.85rem;color:var(--ink,#241F16);cursor:pointer;font-family:inherit;text-align:left;width:100%;min-height:38px}" +
      "html[dir='rtl'] .lang-menu button{text-align:right}" +
      ".lang-menu button:hover{background:var(--ivory,#F6F1E4)}" +
      ".lang-menu button.active{color:var(--gold,#B8912F);font-weight:500}" +
      ".lang-menu button .code{font-size:.68rem;letter-spacing:.06em;color:var(--ink-soft,#5B5544);text-transform:uppercase}" +
      ".lang-menu button.active .code{color:var(--gold,#B8912F)}" +
      ".mobile-lang{display:flex;flex-wrap:wrap;gap:8px;margin-top:6px;padding-top:14px;border-top:1px solid rgba(19,34,65,.08)}" +
      ".mobile-lang button{border:1px solid rgba(19,34,65,.2);border-radius:999px;padding:8px 16px;font-size:.8rem;background:none;color:var(--navy,#132241);font-family:inherit;cursor:pointer;min-height:38px}" +
      ".mobile-lang button.active{background:var(--navy,#132241);color:var(--white,#fff);border-color:var(--navy,#132241)}" +
      ":root{--tap-min:44px}.burger{min-width:44px;min-height:44px;display:flex;align-items:center;justify-content:center}" +
      "a.btn,button.btn{min-height:44px}body.nav-open{overflow:hidden}.nav-inner{flex-wrap:nowrap}" +
      "@media (max-width:1100px){.nav-inner{padding:12px 20px}nav.links{gap:20px}}" +
      "@media (max-width:980px){.hero{min-height:auto;padding-top:110px;padding-bottom:60px}.hero-inner{padding:20px 24px}.nav-right{gap:10px}}" +
      "@media (max-width:640px){.wrap{padding:0 20px}.nav-inner{padding:10px 16px}.brand img{height:36px}.brand-text .ar{font-size:.9rem}.brand-text .sub{font-size:.52rem}.hero h1{font-size:1.85rem;line-height:1.2}.hero p.lead{font-size:.92rem}.cta-row{flex-direction:column;align-items:stretch}.cta-row .btn{width:100%}.page-header{padding:120px 0 50px}.page-header h1{font-size:1.6rem}.section-head h2{font-size:1.5rem}section{padding:56px 0}.lang-menu{right:-8px}.compass-ring{max-width:190px}.pkg-list-side{flex-direction:column;align-items:stretch;gap:12px}.pkg-list-side .btn{width:100%}.event-card .btn{width:100%;margin-top:10px}.job-card .btn{width:100%}}" +
      "@media (max-width:400px){.hero h1{font-size:1.6rem}.compass-ring{max-width:160px}}" +
      "@media (min-width:1440px){.wrap{max-width:1280px}.hero-inner{max-width:1280px}}";
    var style = document.createElement("style");
    style.id = "asfar-lang-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- build dropdown markup, replacing the old 2-button toggle ---------- */
  function buildDesktopSwitcher() {
    var old = document.querySelector(".lang-toggle");
    if (!old) return;
    var wrap = document.createElement("div");
    wrap.className = "lang-switch";
    wrap.id = "langSwitch";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lang-toggle-btn";
    btn.id = "langToggleBtn";
    btn.innerHTML = '<span id="langCurrent">NL</span><svg viewBox="0 0 12 8" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l5 5 5-5"/></svg>';
    var menu = document.createElement("div");
    menu.className = "lang-menu";
    menu.id = "langMenu";
    LANGS.forEach(function (code) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("data-setlang", code);
      b.innerHTML = "<span>" + LANG_NAMES[code] + '</span><span class="code">' + code + "</span>";
      menu.appendChild(b);
    });
    wrap.appendChild(btn);
    wrap.appendChild(menu);
    old.replaceWith(wrap);
  }

  function buildMobileSwitcher() {
    var mobileNav = document.getElementById("mobileNav");
    if (!mobileNav || mobileNav.querySelector(".mobile-lang")) return;
    var wrap = document.createElement("div");
    wrap.className = "mobile-lang";
    LANGS.forEach(function (code) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("data-setlang", code);
      b.textContent = LANG_NAMES[code];
      wrap.appendChild(b);
    });
    mobileNav.appendChild(wrap);
  }

  function getSavedLang() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return LANGS.indexOf(v) > -1 ? v : null;
    } catch (e) { return null; }
  }
  function saveLang(lang) {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) {}
  }

  function applyLang(lang) {
    if (LANGS.indexOf(lang) === -1) lang = "nl";
    document.querySelectorAll(".i18n").forEach(function (el) {
      var val = el.getAttribute("data-" + lang);
      if (val === null) val = el.getAttribute("data-nl");
      if (val !== null) el.textContent = val;
    });
    htmlEl.setAttribute("lang", lang);
    htmlEl.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    htmlEl.setAttribute("data-lang", lang);
    document.querySelectorAll("[data-setlang]").forEach(function (b) {
      b.classList.toggle("active", b.getAttribute("data-setlang") === lang);
    });
    var trigger = document.getElementById("langCurrent");
    if (trigger) trigger.textContent = lang.toUpperCase();
    saveLang(lang);
    document.dispatchEvent(new CustomEvent("asfar:langchange", { detail: { lang: lang } }));
  }

  function initLang() {
    injectStyles();
    buildDesktopSwitcher();
    buildMobileSwitcher();

    var lang = getSavedLang() || "nl";
    applyLang(lang);

    document.querySelectorAll("[data-setlang]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        applyLang(btn.getAttribute("data-setlang"));
        var switchEl = document.getElementById("langSwitch");
        if (switchEl) switchEl.classList.remove("open");
        var menu = document.getElementById("langMenu");
        if (menu) menu.classList.remove("open");
      });
    });

    var toggleBtn = document.getElementById("langToggleBtn");
    var switchEl = document.getElementById("langSwitch");
    var menuEl = document.getElementById("langMenu");
    if (toggleBtn && menuEl) {
      toggleBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        menuEl.classList.toggle("open");
        if (switchEl) switchEl.classList.toggle("open");
      });
      document.addEventListener("click", function (e) {
        if (!menuEl.contains(e.target) && e.target !== toggleBtn) {
          menuEl.classList.remove("open");
          if (switchEl) switchEl.classList.remove("open");
        }
      });
    }
  }

  /* ---------- mobile nav ---------- */
  function initMobileNav() {
    var burger = document.getElementById("burgerBtn");
    var panel = document.getElementById("mobileNav");
    if (!burger || !panel) return;
    burger.addEventListener("click", function () {
      var open = panel.classList.toggle("open");
      burger.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("nav-open", open);
    });
    panel.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        panel.classList.remove("open");
        burger.classList.remove("open");
        document.body.classList.remove("nav-open");
      });
    });
  }

  /* ---------- header shrink shadow ---------- */
  function initHeaderShadow() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    function onScroll() {
      header.classList.toggle("scrolled", window.scrollY > 16);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- journey line / step activation (home page) ---------- */
  function initJourney() {
    var svg = document.getElementById("journeySvg");
    var steps = document.querySelectorAll(".j-step");
    if (!("IntersectionObserver" in window)) return;
    if (svg) {
      var lineObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { svg.classList.add("in-view"); lineObs.unobserve(entry.target); }
        });
      }, { threshold: 0.3 });
      lineObs.observe(svg);
    }
    if (steps.length) {
      var stepObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      }, { threshold: 0.5 });
      steps.forEach(function (s) { stepObs.observe(s); });
    }
  }

  /* ---------- photo placeholder: swap in real photo if it loads ---------- */
  function initPhotoPlaceholders() {
    document.querySelectorAll(".photo-ph[data-src]").forEach(function (ph) {
      var src = ph.getAttribute("data-src");
      if (!src) return;
      var img = new Image();
      img.onload = function () {
        var realImg = document.createElement("img");
        realImg.src = src;
        realImg.alt = ph.getAttribute("data-alt") || "";
        realImg.className = "real";
        realImg.style.display = "block";
        ph.appendChild(realImg);
        ph.querySelectorAll("svg,span").forEach(function (n) { n.style.opacity = "0"; });
      };
      img.onerror = function () {};
      img.src = src;
    });
  }

  /* ---------- active nav link ---------- */
  function markActiveNav() {
    var path = window.location.pathname.replace(/\/$/, "");
    document.querySelectorAll("nav.links a, .mobile-nav a").forEach(function (a) {
      var href = (a.getAttribute("href") || "").replace(/\/$/, "");
      if (href === path || (path === "" && href === "")) a.classList.add("active");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLang();
    initMobileNav();
    initHeaderShadow();
    initReveal();
    initJourney();
    initPhotoPlaceholders();
    markActiveNav();
  });

  window.AsfarSite = { applyLang: applyLang, initPhotoPlaceholders: initPhotoPlaceholders, initReveal: initReveal, LANGS: LANGS };
})();
